/*
 * @Author: Merlin
 * @Date: 2024-01-15 19:32:25
 * @LastEditors: Merlin
 * @LastEditTime: 2024-07-16 10:07:27
 * @Description: 
 */

// ▼用于游戏 hilo
export const oHiloGame = {
    'Coefficient': {
        en: 'Coefficient', 
        cn: '赔率',
    },
    'Probability': {
        en: 'Probability', 
        cn: '概率',
    },
    'skip': {
        en: 'skip', 
        cn: '跳过',
    },
    'theLowest': {
        en: 'ACE BEING●THE LOWEST', 
        cn: 'A是●最低的',
    },
    'theHighest': {
        en: 'KING BEING●THE HIGHEST', 
        cn: 'K是●最高的',
    },
    'Higher': {
        en: 'Higher', 
        cn: '押更高',
    },
    'Lower': {
        en: 'Lower', 
        cn: '押更低',
    },
    'Same': {
        en: 'Same', 
        cn: '相同',
    },
    'HigherOr': {
        en: 'Higher or equal', 
        cn: '押更高或相同',
    },
    'LowerOr': {
        en: 'Lower or equal', 
        cn: '押更低或相同',
    },
    'JackpotDesc': {
        en: 'To win Jackpot you should place bets in Hi-Lo game. The lucky combination is a sequence of cards with a nominal of 7 any suit in one gaming round (the initial card is not counted), skipping the card will discard the previous progress. Percent of Jackpot winnings depends on the bet amount and the distribution is represented below.', 
        cn: '要赢得 Jackpot ，您应在 Hi-Lo 游戏中押注并集齐 4 种花色＂7＂的牌（初始牌不计算在内），跳过牌将丢失进度。 Jackpot 奖金百分比取决于押注金额，分配如下所示。',
    },
    'ruleDesc01': {
        en: 'Predicts whether the next card will be "Higher or equal" or "Lower or equal" than the current card.', 
        cn: '预测下一张牌比当前牌“更高或相同”或者“更低或相同”。',
    },
    'ruleDesc02': { // mini 版中被废弃 
        en: '',
        cn: '',
    },
    'canNotSkip': {
        en: "You can't skip this round! You can maximum skip ● cards!", 
        cn: "不可跳过，最多只能跳 ● 张牌！", 
    },
    '1stCard':{
        en: '1st card',
        cn: '首张牌',
    },
};


